var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProposals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 33 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    transform: "translate(-.617)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M13.479.364c.435-.424 1.117-.463 1.597-.116l.138.116 15.075 14.672c.439.427.475 1.098.11 1.566l-.11.122-5.807 5.786h-9.024L3.948 11.328c-.44-.427-.476-1.098-.11-1.566l.11-.122 9.53-9.276zm.867 1.257l-9.108 8.865L16.072 21h7.778l5.152-5.114L14.346 1.621z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 1.667,
    x: 0.617,
    y: 21,
    rx: 0.833
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M16.33 14.69l13.396 2.596.563-.58c.479-.465.479-1.22 0-1.686L15.244.363c-.478-.465-1.253-.465-1.731 0l-.545.53 2.57 13.009c.08.399.392.71.791.788z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProposals);
export default __webpack_public_path__ + "static/media/icon-proposals.f1a28ebb.svg";
export { ForwardRef as ReactComponent };